import { useCallback, useState } from "react";
import { insertToast } from "~/modules/toasts/services";
import { api } from "~/utils/api";

interface UseCheckoutParams {
	planId?: string;
	extensionId?: string;
}

export function useCheckout() {
	const [isRedirecting, setIsRedirecting] = useState(false);

	const initiatePayment = useCallback(
		async ({ planId, extensionId }: UseCheckoutParams) => {
			setIsRedirecting(true);
			try {
				const response = await api.post("/sales/checkout", {
					planId,
					extensionId,
				});
				const { checkoutUrl } = response.data;

				if (checkoutUrl) {
					window.location.href = checkoutUrl;
				} else {
					throw new Error("Checkout URL not provided by the server.");
				}
			} catch (error: any) {
				setIsRedirecting(false);
				insertToast({
					title: "Erro no Checkout",
					message:
						error.response?.data?.message ||
						"Ocorreu um erro ao gerar o link de pagamento.",
					type: "error",
					duration: 5000,
				});
			}
		},
		[],
	);

	return { initiatePayment, isRedirecting };
}
